import { httpGet } from "../http.service";

class AttandanceService {
  async fetchListing(params: any) {
    return await httpGet<any>("api/v1/admin/attendance", params);
  }
}
const attendanceService = new AttandanceService();
export { attendanceService };
